/**
 * What the open fan hears (ADR-142's note of 2026-10-31): a key, a click, or a press, each with where it landed.
 */
export type FanInput =
  | { readonly kind: "key"; readonly key: string }
  | { readonly kind: "click"; readonly insideBelt: boolean; readonly onToolButton: boolean }
  | { readonly kind: "press"; readonly pointerType: string; readonly insideBelt: boolean; readonly onToolButton: boolean };

/**
 * Whether an input closes the open fan: Escape; a click outside the belt; a touch's press outside the belt, since a tap on
 * the game's canvas raises no click. A mouse's press does not close it, so a drag started in the bag can still land on a
 * slot. The cluster's Tool button is never "outside": its own press toggles the fan, and closing it first would reopen it.
 *
 * @param input What was heard.
 * @returns True when the fan closes.
 * @example
 * fanCloses({ kind: "key", key: "Escape" });
 * // true
 */
export function fanCloses(input: FanInput): boolean {
  switch (input.kind) {
    case "key":
      return input.key === "Escape";
    case "click":
      return !input.insideBelt && !input.onToolButton;
    case "press":
      return input.pointerType === "touch" && !input.insideBelt && !input.onToolButton;
  }
}
